import React from 'react';

const Header = () => {
    return (
        <div className='text-5xl font-bold bg-violet-300 mt-8 p-8 w-1/2 mr-auto ml-auto mt-10 '>
            <h1>Ready to Start the Quiz?</h1>
        </div>
    );
};

export default Header;